import React, { createContext, ReactNode, useContext, useState } from 'react';

interface PrototypeContextType {
  selectedTenant: string;
  setSelectedTenant: (tenant: string) => void;
  selectedYear: string;
  setSelectedYear: (year: string) => void;
  isMasterTenant: boolean;
}

const PrototypeContext = createContext<PrototypeContextType | undefined>(undefined);

export const PrototypeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [selectedTenant, setSelectedTenant] = useState('Master');
  const [selectedYear, setSelectedYear] = useState('2025');

  const isMasterTenant = selectedTenant === 'Master';

  return (
    <PrototypeContext.Provider
      value={{
        selectedTenant,
        setSelectedTenant,
        selectedYear,
        setSelectedYear,
        isMasterTenant,
      }}
    >
      {children}
    </PrototypeContext.Provider>
  );
};

export const usePrototype = (): PrototypeContextType => {
  const context = useContext(PrototypeContext);
  if (!context) {
    throw new Error('usePrototype must be used within a PrototypeProvider');
  }
  return context;
};
